import {
  AutoComplete,
  AutoCompleteProps
} from "@fidget/common/components/form/autoComplete/autoComplete";
import { intl } from "@fidget/common/i18n/TypedIntl";
import classNames from "classnames";
import { observer } from "mobx-react";
import React from "react";
import settingsStyles from "../../../styles/settings.css";

export type Capacity = { name: string; value: number | undefined };

interface Props extends Omit<Partial<AutoCompleteProps<Capacity>>, "onChange"> {
  onChange(capacity: Capacity): void;
  value?: Capacity;
  itemsProvider: () => Capacity[];
}

export const CapacityPicker = observer(
  ({ onChange, value, itemsProvider, className, ...autoCompleteProps }: Props) => {
    return (
      <AutoComplete<Capacity>
        {...autoCompleteProps}
        className={classNames(settingsStyles["input-max-width-bigger"], className)}
        onChange={onChange}
        itemsProvider={itemsProvider}
        itemToString={(val) => (val !== null ? val.name : "")}
        placeholder={intl.formatMessage("capacityPicker.placeholder")}
        readOnly
        inputValue={value?.toString()}
        emptyPlaceholder={intl.formatMessage("capacityPicker.empty")}
      />
    );
  }
);
